import type { GameId } from "@shared/types";

export type AnyGame = GameId | "joker" | "guess";

export interface GameMeta {
  id: AnyGame;
  href: string;
  color: string;
  deep: string;
  ink: string;
  video?: string;
  poster: string;
  mascot: string;
}

const m = (id: AnyGame, href: string, ink: string, video = true): GameMeta => ({
  id,
  href,
  color: `var(--color-${id})`,
  deep: `var(--color-${id}-deep)`,
  ink,
  video: video ? `video/${id}.mp4` : undefined,
  poster: `img/games/${id}-frame.webp`,
  mascot: `img/games/${id}.webp`,
});

export const GAME_LIST: GameMeta[] = [
  m("bluff", "/play/bluff", "#fff"),
  m("spy", "/play/spy", "#132100"),
  m("guess", "/guess", "#2a0f00"),
  m("match", "/play/match", "#2a0022"),
  m("truf", "/play/truf", "#00243a"),
  m("joker", "/joker", "#2b1d00"),
];

export const gameMeta = (id: AnyGame) => GAME_LIST.find((g) => g.id === id)!;
